import Vue from 'vue'
import App from './App'

// api
import '@/shared/services/api'

// plugins
import '@/shared/plugins'


// router
import router from './router'

// Configurações do módulo
Vue.prototype.$urlBase = '/site'

new Vue({
    router,
    render: h => h(App)
}).$mount('#app')
